import React, { Fragment } from 'react';
import { Card, Checkbox, Row, Tag } from 'antd';

export default ({product}) => {

	return <Fragment>
		<Card title="Thông tin thêm">
			<Row>
				<Checkbox className={'mb-10'} checked={product.status} disabled>Cho phép bán</Checkbox> <br/>
				<Checkbox checked={product.warrantyPolicyId !== null} disabled>Áp dụng bảo hành</Checkbox><br/>
				{product.warrantyPolicyName && <i style={{marginLeft: '25px', color: 'rgba(0, 0, 0, 0.25)'}}>{product.warrantyPolicyName}</i>}
			</Row>
		</Card>
	</Fragment>
}
